module.exports = __webpack_public_path__ + "static/media/BGP-CTISeries.5ee0c42e.pdf";